import { render } from "./ComboBox.vue?vue&type=template&id=1c72b896&ts=true"
import script from "./ComboBox.ts?vue&type=script&lang=ts&external"
export * from "./ComboBox.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__